import { Box, Checkbox, Input, Stack } from '@chakra-ui/react'
import React, { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'

function FilterBox() {
    let [searchParams, setSearchParams] = useSearchParams()

    let initialParams = searchParams.getAll("category")

    let [category, seCategory] = useState(initialParams || [])

    let handlecheckbox = (e) => {

        let newCategory = [...category]
        if (newCategory.includes(e.target.value)) {
            //   if newCategory includes e.target.value then remove
            newCategory.splice(newCategory.indexOf(e.target.value), 1)
        } else {
            //   if newCategory dosenot includes e.target.value then add to the newCategory
            newCategory.push(e.target.value)
        }
        seCategory(newCategory)
    }
    useEffect(() => {
        let params = {}
        category && (params.category = category)
        setSearchParams(params)
        console.log(params)

    }, [setSearchParams, category])

    return (
        <Box w={"98%"} display={"flex"} flexDir={"column"} p={5} m={"auto"}>
            <Box bgColor={"red.100"} p={2} color={"white"} fontWeight={700} fontSize={20}>
                Filter By Category
            </Box>
            <Box pt={5} fontWeight={700}>
                <Stack direction={["column", "column", "row", "row", "row"]}>
                    <Checkbox value={"electronics"} size='md' colorScheme='green' isDisabled={category.length > 0 && !category.includes("electronics")} onChange={handlecheckbox} defaultChecked={category.includes("electronics")}>
                        electronics

                    </Checkbox>
                    <Checkbox value={"jewelery"} size='md' colorScheme='green' isDisabled={category.length > 0 && !category.includes("jewelery")} onChange={handlecheckbox} defaultChecked={category.includes("jewelery")}>
                        jewelery
                    </Checkbox>
                    <Checkbox size='md' value={"men's clothing"} colorScheme='green' isDisabled={category.length > 0 && !category.includes("men's clothing")} onChange={handlecheckbox} defaultChecked={category.includes("men's clothing")}>
                        men's clothing
                    </Checkbox>
                    <Checkbox size='md' value={"women's clothing"} colorScheme='green' isDisabled={category.length > 0 && !category.includes("women's clothing")} onChange={handlecheckbox} defaultChecked={category.includes("women's clothing")}>
                        women's clothing
                    </Checkbox>
                </Stack>
            </Box>

        </Box>
    )
}

export default FilterBox